import { useEffect, useState } from 'react';

export const pageIsVisible = () => document.visibilityState !== 'hidden';

export function usePageVisibility() {
  const [visible, setVisible] = useState(pageIsVisible);
  useEffect(() => {
    const changed = () => setVisible(pageIsVisible());
    document.addEventListener('visibilitychange', changed);
    changed();
    return () => document.removeEventListener('visibilitychange', changed);
  }, []);
  return visible;
}
